import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import uuidv4 from 'uuid/v4'
import { useActions } from '../../hooks/useActions'
import { useLocalization } from '../../redux/reduxHooks'
import { renderContent, getLabel } from '../../utils/helpers'
import { Respondent as RespoondentLabel } from '../../utils/QuestionnaireStateManager'
import DateInput from '../../widgets/DateInput'
import FollowUpQuestions from '../../widgets/FollowUpQuestions'
import TextFieldQuestion from '../../widgets/TextFieldQuestion'

function RespondentDetails({ respondent, setRespondentNotes, config }) {
  const { name: { firstName = '', lastName = '' } = {}, dateOfBirth = {} } = respondent.person || {}
  const { setRespondentFirstName, setRespondentLastName, setRespondentDob } = useActions()
  const localization = useLocalization()

  return (
    <>
      <Typography sx={{ pb: 3, paddingX: 2 }}>
        If you have been referred because your spouse or relative has died, complete the form with
        their information. For example, please complete the “Your Information” section with your
        relative’s information instead of your own in this situation
      </Typography>
      <FollowUpQuestions>
        Please fill out your personal details
        {renderContent({
          renderMap: {
            // we should consider consolidating first/last to be respondent-name
            respondentFirst: (
              <Box key="res-name" display="flex" gap={3}>
                <TextFieldQuestion
                  handleChange={(value) => setRespondentFirstName({ value })}
                  value={firstName}
                  label="Respondent First Name"
                  multiline={false}
                />
                <TextFieldQuestion
                  handleChange={(value) => setRespondentLastName({ value })}
                  value={lastName}
                  label="Respondent Last Name"
                  multiline={false}
                />
              </Box>
            ),
            respondentDob: (
              <DateInput
                key="res-dob"
                label="Respondent Date of Birth"
                dateOfBirth={dateOfBirth}
                handleChange={({ value, dateType }) => {
                  setRespondentDob({ dateType, value })
                }}
              />
            ),
            respondentReason: (
              <TextFieldQuestion
                key="res-reason"
                fullWidth
                value={respondent.notes || ''}
                handleChange={(value) => setRespondentNotes({ value })}
                label={getLabel(localization, RespoondentLabel.RESPONDENT_REASON)}
              />
            ),
          },
          config,
        })}
      </FollowUpQuestions>
    </>
  )
}

export default function Respondent({ config }) {
  const respondent = useSelector(({ questionnaire }) => questionnaire.respondent) || {}
  const { setRespondentPerson, setRespondentNotes, removeRespondentPerson } = useActions()
  const isChecked = !!respondent?.person

  return (
    <>
      <FormControlLabel
        label={
          <Typography id="is-respondent-label" fontWeight="500">
            Are you filling this out on behalf of someone else?
          </Typography>
        }
        control={
          <Checkbox
            checked={isChecked}
            onChange={({ currentTarget: { checked } }) => {
              checked ? addRespondentPerson() : cleanUpRespondentPerson()
            }}
            inputProps={{
              'aria-labelledby': 'is-respondent-label',
            }}
          />
        }
        sx={{ py: 1 }}
      />
      {isChecked ? (
        <RespondentDetails
          respondent={respondent}
          setRespondentNotes={setRespondentNotes}
          config={config}
        />
      ) : null}
    </>
  )

  function addRespondentPerson() {
    const id = uuidv4()
    setRespondentPerson({ value: { id, relationshipToProband: 'unknown' } })
  }
  function cleanUpRespondentPerson() {
    removeRespondentPerson()
    setRespondentNotes('')
  }
}
